import { useDialog } from "shared/dialog/use-dialog";
import { CreateListDialog } from "../favorite-list-components/create-list-dialog";
import { usePostApiAccountFavoritesMutation } from "api/generatedApi";
import { useTranslation } from "react-i18next";
import { useToast } from "shared/toast/hooks/use-toast";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { SubmitHandler } from "react-hook-form";

export const useCreateList = () => {
  const { t } = useTranslation();
  const toast = useToast();

  const [openCreateListDialog, closeCreateListDialog] = useDialog(CreateListDialog);
  const [createList] = usePostApiAccountFavoritesMutation();

  const handleSuccess = () => {
    closeCreateListDialog();
  };

  const wrapMutation = useMutation({
    onSuccess: handleSuccess,
    successProps: {
      description: t("account.favorites.createListToastSuccess"),
    },
    onError: () => toast.error(t("account.favorites.createListError")),
    resultDialogType: ResultDialogType.Toast,
  });

  const handleOnSubmit: SubmitHandler<{ name: string }> = (data) => {
    wrapMutation(
      createList({
        createPersonalFavoriteListRequest: { name: data.name },
      })
    );
  };

  const handleClick = () => {
    openCreateListDialog({ onSubmit: handleOnSubmit });
  };

  return handleClick;
};
